import React from 'react';
import type { CheckboxProps } from '@components/moleculs/checkbox/types';
import cn from 'classnames';

import { Cb, FormControlLabelStyled } from './styles';

export const Checkbox: React.FC<CheckboxProps> = ({ fieldState, label, className, ...rest }) => (
    <FormControlLabelStyled
        className={cn('MuiCheckbox-root', className)}
        label={label}
        control={<Cb {...rest} />}
        labelPlacement='end'
    />
);
